var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-elem',{staticClass:"default-page"},[_c('sections-elem',{attrs:{"content":_vm.$store.state.page.content.sections}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }